import React from 'react';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import ImageEditingFormSome from "./ImageEditingFormSome";

// State型定義
interface RootState {
  imageEditing: {
    [key: string]: any;
  };
  [key: string]: any;
}

// mapStateToPropsの型定義
function mapStateToProps(state: RootState) {
  return { ...state.imageEditing };
}

// コンポーネントのProps型定義
interface ImageEditingFormProps {
  [key: string]: any;
}

const ImageEditingForm: React.FC<ImageEditingFormProps> = (props) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();

  return (
    <>
      <ImageEditingFormSome />
    </>
  );
};

export default connect(mapStateToProps)(ImageEditingForm);